import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { PERMISSION } from 'src/features/auth';
import { ICON_MAP } from 'src/features/parkingStatus/utils';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/utils/messages';

import type { CellContext } from '@tanstack/react-table';
import type { GuestReason } from 'src/features/parkingManagement/api/ReasonsForGuest/useGetParkingGuestReasons';

interface ReasonsForGuestActionsProps<TData, TValue> extends CellContext<TData, TValue> {
    editCallback?: (version: TData) => void;
    deleteCallback?: (version: TData) => void;
}

function ReasonsForGuestActions({
    row,
    editCallback,
    deleteCallback,
}: ReasonsForGuestActionsProps<GuestReason, unknown>) {
    const { formatMessage } = useIntl();
    const permissionDetailsManage = useHasPermissions([PERMISSION.PARKING_DETAILS_MANAGE]);

    return (
        <div className="flex gap-1">
            {permissionDetailsManage && (
                <>
                    {editCallback && (
                        <TooltipProvider>
                            <Tooltip>
                                <TooltipTrigger asChild>
                                    <Button onClick={() => editCallback!(row.original)} size="icon" variant="link">
                                        <FontAwesomeIcon icon={ICON_MAP.EDIT} className="cursor-pointer" />
                                    </Button>
                                </TooltipTrigger>
                                <TooltipContent side="top">{formatMessage(generalMessages.edit)}</TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                    )}
                    {deleteCallback && (
                        <TooltipProvider>
                            <Tooltip>
                                <TooltipTrigger asChild>
                                    <Button onClick={() => deleteCallback!(row.original)} size="icon" variant="link">
                                        <FontAwesomeIcon icon={ICON_MAP.DELETE} className="cursor-pointer" />
                                    </Button>
                                </TooltipTrigger>
                                <TooltipContent side="top">{formatMessage(generalMessages.delete)}</TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                    )}
                </>
            )}
        </div>
    );
}

export { ReasonsForGuestActions };
